import { render, staticRenderFns } from "./SettsFAQ.vue?vue&type=template&id=6a6ccfc2"
import script from "./SettsFAQ.vue?vue&type=script&lang=js"
export * from "./SettsFAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports